export default "__VITE_ASSET__3GVKnI9n__"